import React from 'react';
import styles from './index.module.less';
import PanelItem from './item';
import Icon from '@/components/Icon';
import { useTranslation } from 'react-i18next';

interface IProps {
  header?: string | React.ReactElement;
  showFooter?: boolean;
  onPressFooter?: () => void;
}
const Panel: React.FC<IProps> & { Item: typeof PanelItem } = ({
  header,
  showFooter,
  onPressFooter,
  children,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.container}>
      {Boolean(header) && (
        <div>
          {typeof header === 'string' ? (
            <div className={styles.header}>
              <p className={styles.text}>{header}</p>
            </div>
          ) : (
            header
          )}
        </div>
      )}
      {children}
      {showFooter && (
        <div className={styles.footer} onClick={() => onPressFooter?.()}>
          <p>{t('see_more')}</p>
          <Icon iconName={'arrow_right'} imgClass={styles.arrow} />
        </div>
      )}
    </div>
  );
};
Panel.Item = PanelItem;

export { PanelItem };
export default Panel;
